type FormattedName = {
  displayName: string
  initials: string
}

/**
 * Formats a name into various formats including initials
 * @param name - The full name to format
 * @returns Object containing firstName, displayName (with last initial), and initials
 */
export const formatCarrotCompanionName = (name?: string): FormattedName => {
  if (!name) {
    return {
      displayName: "",
      initials: ""
    }
  }

  const [firstName, lastName] = name.split(" ")
  const lastInitial = `${lastName.charAt(0).toUpperCase()}`
  const firstInitial = firstName.charAt(0).toUpperCase()

  return {
    displayName: `${firstName} ${lastInitial}.`,
    initials: `${firstInitial}${lastInitial}`
  }
}
